import { render } from "./CheckoutView.vue?vue&type=template&id=1c5bb2a4&scoped=true"
import script from "./CheckoutView.vue?vue&type=script&lang=js"
export * from "./CheckoutView.vue?vue&type=script&lang=js"

import "./CheckoutView.vue?vue&type=style&index=0&id=1c5bb2a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5bb2a4"]])

export default __exports__